import request from '@/api/request';
import { materialUpload } from "@/api/globalVar";
import qs from "querystring";
let vi = '/v2'
//  a列表
export function getList(data) {
  return request({
    url: `${vi}/Hotelserviceconfig/serviceConfig`,
    method: 'post',
    data,
  });
}
// 新增
export function create(data) {
  return request({
    url: `${vi}/Hotelserviceconfig/addServiceConfig`,
    method: 'post',
    data,
  });
}
// 修改
export function updateData(data) {
  return request({
    url: `${vi}/Hotelserviceconfig/editServiceConfig`,
    method: 'post',
    data,
  });
}
// 删除
export function allDelete(data) {
  return request({
    url: `${vi}/Hotelserviceconfig/delallServiceConfig`,
    method: 'post',
    data,
  });
}

